import { $api } from "../AxiosInstance";

export class PriceService {
  /**
   * Get all prices
   */
  static async getPrices() {
    return await $api.get("/api/admin/price/all");
  }

  /**
   * Get IPv4 prices grouped by currency
   */
  static async getPricesIPv4() {
    return await $api.get("/api/admin/price/all/groupByCurrency");
  }

  /**
   * Get IPv6 prices
   */
  static async getPricesIPv6() {
    return await $api.get("/api/admin/priceIPv6/all");
  }

  /**
   * Get ISP prices
   */
  static async getPricesISP() {
    return await $api.get("/api/admin/priceISP/all");
  }

  /**
   * Save ISP price
   * @param {Object} params
   */
  static async savePriceISP(params) {
    return await $api.post("/api/admin/priceISP", params);
  }

  /**
   * Get all mobile prices
   */
  static async getPricesMobileAll() {
    return await $api.get("/api/admin/priceMobile/all");
  }

  /**
   * Update IPv4 prices
   */
  static async updatePricesIpv4() {
    return await $api.post("/api/price/updateAll");
  }

  /**
   * Save IPv6 prices
   * @param {Object} params
   */
  static async saveIPv6Prices(params) {
    return await $api.post("/api/admin/priceIPv6", params);
  }

  /**
   * Change price for project
   * @param {Number} id
   * @param {Number} projectId
   * @param {Number} currencyId
   * @param {Number} countryId
   * @param {Number} amount
   */
  static async changePriceForProject(id, projectId, currencyId, countryId, amount) {
    return await $api.post("/api/admin/priceForProjectService", {
      id,
      projectId,
      currencyId,
      countryId,
      amount,
    });
  }

  /**
   * Add price for project
   * @param {Number} projectId
   * @param {Number} currencyId
   * @param {Number} countryId
   * @param {Number} amount
   */
  static async addPriceForProject(projectId, currencyId, countryId, amount) {
    return await $api.put("/api/admin/priceForProjectService", {
      projectId,
      currencyId,
      countryId,
      amount,
    });
  }

  /**
   * Delete price for project
   * @param {Number} id
   */
  static async deletePriceForProject(id) {
    return await $api.delete("/api/admin/priceForProjectService", {
      params: { id },
    });
  }
}
